<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 赋码管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>生码查询表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="80px">
          <el-row>
            <el-col :span="7">
              <el-form-item label="订单" prop="qrcode_orderno">
                <el-input v-model="searchform.qrcode_orderno" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="供应商编号" prop="supplierid" label-width="100px">
                <el-input v-model="searchform.supplierid" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="追溯码" prop="qrcode">
                <el-input v-model="searchform.qrcode" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="search"
                v-permission="['rulenews_select']"
              >搜索</el-button>
              <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button
                v-permission="['rulenews_export']"
                :loading="downloadLoading"
                type="primary"
                icon="document"
                @click="download"
              >导出Excel</el-button>
            </el-col>
          </el-row>
        </el-form>
        <br />
      </div>

      <el-row type="flex" class="row-bg">
        <el-col :span="22" class="border">
          <h4>生码查询表</h4>
          <el-divider></el-divider>
          <el-table
            v-loading="listLoading"
            element-loading-text="拼命加载中"
            :data="tableData"
            style="width:100%;"
            id="parent"
            border
          >
            <el-table-column prop="id" label="编号" min-width="70" show-overflow-tooltip></el-table-column>
            <el-table-column prop="qrcode_orderno" label="订单" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column prop="supplier" label="供应商" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column prop="market" label="营销码" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column prop="qrcode" label="追溯码" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column prop="create_time" label="生码时间" min-width="150" show-overflow-tooltip></el-table-column>
          </el-table>
          <br />
          <el-pagination
            background
            @current-change="currentchange"
            @size-change="pagesize"
            :current-page.sync="currentPage"
            :page-sizes="[20,30,40,5000]"
            layout="total,prev, pager, next,jumper,sizes"
            :total="total_count"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { getlist } from "@/api/tagging";
//引入导出组件模块
import axios from "axios";
import store from "@/store";
import { getToken } from "@/utils/auth";
export default {
  mounted() {
    //请求部门列表数据并且便利到表格
    // this.Tabledata();
  },
  data() {
    return {
      //导出表格变量
      tableDataDownload: [],
      listLoading: true,
      downloadLoading: false,
      filename: "",
      autoWidth: true,
      bookType: "xlsx",
      //基础数据
      listLoading: false,
      depart_uuid: [],
      tableData: [],
      //分页数据
      pagesizes: "",
      total_count: 1,
      currentPage: 1,
      //搜索表单数据
      searchform: {
        qrcode_orderno: "",
        qrcode: "",
        supplierid: "",
        page_index: 1,
        page_size: 20
      }
    };
  },
  methods: {
    // base64转成 blob
    //         let blob = new Blob([data], {
    //   type: 'application/octet-stream'
    // });// 转化为blob对象
    dataURLtoBlob(dataurl) {
      var bstr = atob(dataurl);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: "pdf" });
    },
    // 导出
    download() {
      setTimeout(() => {
        const form = {
          supplier_id: this.searchform.supplierid,
          qrcodeOrderno: this.searchform.qrcode_orderno,
          qrcode: this.searchform.qrcode,
          pageStartIndex: 1,
          pageEndIndex: 1,
          page_size: 1000000
        }; // 要发送到后台的数据
        console.log(this.form);
        axios({
          // 用axios发送post请求
          method: "post",
          url:
            process.env.VUE_APP_BASE_API_tagging +
            "/api/produce/qrcode/dowmexcel", // 请求地址
          data: form, // 参数
          headers: {
            token: getToken()
          }
        }).then(response => {
          if (response.data.status_code == 200) {
            // 处理返回的文件流
            this.downloadLoading = true;
            const content = this.dataURLtoBlob(response.data.data);
            const blob = new Blob([content]);
            const fileName = response.data.message;
            if ("download" in document.createElement("a")) {
              // 非IE下载
              const elink = document.createElement("a");
              elink.download = fileName;
              elink.style.display = "none";
              elink.href = URL.createObjectURL(blob);
              document.body.appendChild(elink);
              elink.click();
              URL.revokeObjectURL(elink.href); // 释放URL 对象
              document.body.removeChild(elink);
              if (window.navigator.msSaveBlob) {
                // ie下载
                console.log(window.navigator.msSaveBlob);
                try {
                  window.navigator.msSaveBlob(blob, fileName);
                } catch (e) {
                  console.log(e);
                }
              }
              setTimeout(() => {
                this.downloadLoading = false;
              }, 500);
            } else {
              // IE10+下载
            }
          } else {
            this.$message({
              type: "warning",
              message: response.data.message
            });
          }
        });
      }, 300);
    },
    //请求表格数据
    tablefor(obj) {
      for (let i = 0; i < obj.length; i++) {
        obj[i].create_time = obj[i].create_time.replace(/T/, " ");
        obj[i].create_time = obj[i].create_time.replace(/T/, " ");
        if (obj[i].supplier_name !== null) {
          obj[i].supplier = obj[i].supplier_id + obj[i].supplier_name;
        } else {
          obj[i].supplier = obj[i].supplier_id;
        }
      }
    },
    Tabledata(obj) {
      this.listLoading = true;
      getlist(obj).then(response => {
        this.tableData = response.data.data;

        this.tablefor(this.tableData);
        this.total_count = response.data.total_count;
        console.log(this.total_count);
        this.listLoading = false;
        console.log(response.data);
      });
    },
    //搜索事件
    search() {
      this.Tabledata({
        page_size: this.searchform.page_size,
        supplier_id: this.searchform.supplierid,
        qrcode_orderno: this.searchform.qrcode_orderno,
        qrcode: this.searchform.qrcode
      });
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //分页跳转事件
    currentchange(page_index) {
      this.searchform.page_index = page_index;
      this.Tabledata({
        page_index: this.searchform.page_index,
        page_size: this.searchform.page_size,
        supplier_id: this.searchform.supplierid,
        qrcode_orderno: this.searchform.qrcode_orderno,
        qrcode: this.searchform.qrcode
      });
    },
    //分页每页显示条数事件
    pagesize(page_size) {
      this.searchform.page_size = page_size;
      this.search();
    },
    //导出表格事件
    handleDownload() {
      this.downloadLoading = true;
      const obj = {
        page_index: 1,
        page_size: this.total_count,
        supplier_id: this.searchform.supplierid,
        qrcode_orderno: this.searchform.qrcode_orderno,
        qrcode: this.searchform.qrcode
      };
      getlist(obj).then(response => {
        this.tableDataDownload = response.data.data;
        this.tablefor(this.tableDataDownload);
        import("@/vendor/Export2Excel").then(excel => {
          const tHeader = [
            "编号",
            "订单",
            "供应商",
            "营销码",
            "码",
            "创建时间"
          ];
          const filterVal = [
            "id",
            "qrcode_orderno",
            "supplier",
            "market",
            "qrcode",
            "create_time"
          ];
          const list = this.tableDataDownload;
          const data = this.formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: this.filename,
            autoWidth: this.autoWidth,
            bookType: this.bookType
          });
          this.downloadLoading = false;
        });
      }); // hear
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j === "timestamp") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    }
  }
};
</script>
<style scoped>
.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 10px 0;
}
.border {
  padding: 10px 10px;
  border-radius: 3px;
  border: 1px solid #e6ebf5;
  background-color: #fff;
  overflow: hidden;
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
}
.handle-box {
  margin-bottom: 0px;
}
.handle-input {
  width: 160px;
  display: inline-block;
}
.del-dialog-cnt {
  font-size: 16px;
  text-align: center;
}
.mr10 {
  margin-right: 10px;
}
#parent {
  text-align: center;
}
</style>
